





























































































































































































































































































































































































































































import BaseComponent from '@/core/base.component';
import { Component, Vue, Prop } from 'vue-property-decorator';
import AnalysisTabService from '@/services/analysis/analysis-tab.service';
import BaeminCategoryService from '@/services/analysis/baemin-category.service';
import {
  BAEMIN_CATEGORY_CODE_KOREAN,
  CONST_BAEMIN_CATEGORY_CODE_KOREAN,
} from '@/services/shared';
import DashboardPieChart from '../../dashboard/add-on/DashboardPieChart.vue';
import DashboardBarChart from '../../dashboard/add-on/DashboardBarChart.vue';
import { AnalysisTabListDto } from '@/dto';
import { ReverseQueryParamMapper } from '@/core';
import toast from '../../../../resources/assets/js/services/toast.js';

@Component({
  name: 'AnalysisSales',
  components: {
    DashboardPieChart,
    DashboardBarChart,
  },
})
export default class AnalysisSales extends BaseComponent {
  @Prop() bdongCode!: string;
  private analysisTabSearchDto = new AnalysisTabListDto();
  private baeminCategories: BAEMIN_CATEGORY_CODE_KOREAN[] = [
    ...CONST_BAEMIN_CATEGORY_CODE_KOREAN,
  ];
  private revenueCategories = [];
  private genderCountData = null;
  private genderRevenueData = null;
  private ageRevenueData = null;
  private dayCountData = null;
  private dayRevenueData = null;
  private dataLoading = false;
  private dataLoadingRevenueCategory = false;
  private dataLoadingByTime = false;
  private clickedCategory = false;
  private lunchData = [];
  private dinnerData = [];
  private lateNightData = [];

  private pieOptions = { responsive: true };
  private barOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };
  resetData() {
    this.genderCountData = null;
    this.genderRevenueData = null;
    this.ageRevenueData = null;
    this.dayCountData = null;
    this.dayRevenueData = null;
  }
  async findRevenueAnalysis(categoryName?: BAEMIN_CATEGORY_CODE_KOREAN) {
    if (!this.bdongCode) {
      return;
    }
    this.resetData();
    this.clickedCategory = true;
    this.analysisTabSearchDto.bdongCode = this.bdongCode;

    this.analysisTabSearchDto.baeminCategoryName = categoryName;
    if (!categoryName) {
      this.analysisTabSearchDto.baeminCategoryName =
        BAEMIN_CATEGORY_CODE_KOREAN.KOREAN;
    }

    await Promise.all([
      await this.findRevenueAnalysisGender(),
      await this.findRevenueAnalysisAgeGroup(),
      await this.findRevenueAnalysisByDay(),
    ]);
  }

  findCategoryRatio() {
    this.dataLoadingRevenueCategory = true;
    AnalysisTabService.findCategoryRatio(this.analysisTabSearchDto).subscribe(
      res => {
        if (res) {
          this.dataLoadingRevenueCategory = false;
          this.revenueCategories = res.data;
        }
      },
    );
  }

  findRevenueAnalysisGender() {
    this.dataLoading = true;
    AnalysisTabService.findRevenueAnalysisGender(
      this.analysisTabSearchDto,
    ).subscribe(res => {
      if (res && res.data) {
        this.dataLoading = false;
        if (res.data[0]) this.genderCountData = res.data[0].countData;
        if (res.data[1]) this.genderRevenueData = res.data[1].revenueData;
      }
    });
  }

  findRevenueAnalysisAgeGroup() {
    AnalysisTabService.findRevenueAnalysisAgeGroup(
      this.analysisTabSearchDto,
    ).subscribe(res => {
      if (res && res.data) {
        if (res.data[1]) this.ageRevenueData = res.data[1].revenueData;
      }
    });
  }

  findRevenueAnalysisByDay() {
    AnalysisTabService.findRevenueAnalysisByDay(
      this.analysisTabSearchDto,
    ).subscribe(res => {
      if (res && res.data) {
        if (res.data[0]) this.dayCountData = res.data[0].countData;
        if (res.data[1]) this.dayRevenueData = res.data[1].revenueData;
      }
    });
  }

  async findRevenueAnalysisByTime() {
    if (!this.bdongCode) {
      return;
    }
    this.analysisTabSearchDto.bdongCode = this.bdongCode;

    await Promise.all([
      await this.findBestByDinner(),
      await this.findBestByLunch(),
      await this.findBestByLateNight(),
    ]);
  }

  findBestByLunch() {
    AnalysisTabService.findBestCatByLunch(this.analysisTabSearchDto).subscribe(
      res => {
        this.lunchData = res.data;
      },
    );
  }

  findBestByDinner() {
    AnalysisTabService.findBestCatByDinner(this.analysisTabSearchDto).subscribe(
      res => {
        this.dinnerData = res.data;
      },
    );
  }

  findBestByLateNight() {
    this.dataLoadingByTime = true;
    AnalysisTabService.findBestCatByLateNight(
      this.analysisTabSearchDto,
    ).subscribe(res => {
      this.dataLoadingByTime = false;
      this.lateNightData = res.data;
    });
  }
  created() {
    this.findCategoryRatio();
    this.findRevenueAnalysisByTime();
  }
}
